import {
  name,
} from "../utils/dom";
import VerifyBadge from "./verify-badge";
import Link from "next/link";

interface CompanionPhoto {
  thumbUrl?: string;
  url?: string;
}

interface Companion {
  id?: number;
  username?: string;
  firstName?: string;
  lastName?: string;
  trustLevel?: number;
  photos?: CompanionPhoto[] | { thumbUrl?: string };
}

const UserViz = ({ companion, title }: { companion: Companion; title: React.ReactNode }) => {
  if (companion?.id == null) return "";
  const lastDigit = companion.id % 10;

  // Handle various photo formats safely
  let companionPhoto = null;
  if (companion.photos) {
    if (Array.isArray(companion.photos)) {
      // photos is an array with at least one item
      if (companion.photos.length > 0 && companion.photos[0]) {
        companionPhoto = companion.photos[0].thumbUrl || companion.photos[0].url;
      }
    } else if (companion.photos.thumbUrl) {
      // photos is an object with thumbUrl
      companionPhoto = companion.photos.thumbUrl;
    }
  }

  // Use placeholder if no photo or if it's the default
  companionPhoto =
    (!companionPhoto || companionPhoto.includes("default_t.jpg"))
      ? `/images/svg/profile-placeholder-${lastDigit}.svg`
      : companionPhoto;
  return (
    <div className="user-brief">
      <div className="profile-pic">
        <img src={companionPhoto} className="profile-pic-image" alt="User profile" />
        <VerifyBadge user={companion} text={true} />
      </div>
      <div className="right">
        <div className="text">
          {title}
          <br />
          <span className="name">{name(companion)}</span>
        </div>
      </div>
    </div>
  )
}

const UserBrief = ({ companion, title = "", clickable = false }: { companion: Companion; title?: React.ReactNode; clickable?: boolean }) => {
  // Use username if available, otherwise fall back to ID
  const slug = companion?.username || companion?.id || "";
  const isWorthy = companion?.trustLevel >= 2;

  const inside = <UserViz companion={companion} title={title} />;
  const href = clickable ? `/s/${slug}` : "";
  const extraProps = isWorthy ? {id:"verify-tooltip-cont"} : {}
  return clickable ? (
    <Link
      href={href}
      className="user-brief"
      {...extraProps}
    >
      {inside}
    </Link>
  ) : (
    <div className="user-brief-cont">{inside}</div>
  );
};

export default UserBrief;
